module.exports = __webpack_public_path__ + "static/media/pexels-photo-6347888.afb63dee.jpeg";